import { render, staticRenderFns } from "./clear-mfa.vue?vue&type=template&id=0aa3684f"
import script from "./clear-mfa.vue?vue&type=script&lang=ts"
export * from "./clear-mfa.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports